"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPORT_CANCEL = void 0;
const REPORT_CANCEL = exports.REPORT_CANCEL = 'report-cancel';
